import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialRecommendations } from '../../report/editorial';

function mergeUniqueStrings(...groups: (string[] | undefined)[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const group of groups) {
    for (const item of group ?? []) {
      const t = item.trim();
      if (!t || seen.has(t)) continue;
      seen.add(t);
      out.push(t);
    }
  }
  return out;
}

export const ActionPlanSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const recs = mergeUniqueStrings(
    report.powerAnalysis?.recommendations,
    report.conclusion?.nextActions,
  );
  return (
    <SectionShell label={label} hasData={recs.length > 0}>
      <EditorialRecommendations
        theme={theme}
        items={recs}
        heading={label ?? 'Recommendations'}
        marker={theme.headingScale === 'compact' ? 'decimal' : 'roman'}
      />
    </SectionShell>
  );
};
